const config = {
  // 以风控系统 risk-front 为例
  devPort: 8091, // 开发端口,需要跟主应用中注册的子应用 host 和 port 保持一致，对应 entry 字段
  name: 'billing-front', // 子应用项目标识，跟主应用中注册的项目标识一致，建议子应用域名也取该字段值，比如 http://testsupport.tsign.cn/riskfront/
  buildPath: 'support-microfe/billing-front', // 打包路径，用于上传到 oss 或服务器
  microfeOptions: {
    base: '/billing', // 子应用在 qiankun 中运行时的路由 base，此处为路由，并非域名，对应主应用中注册的 activeRule 字段,如  http://testsupport.tsign.cn/microfe/risk/
  },
  externals: {
    'vue-router': 'VueRouter',
    vue: 'Vue',
  },
}
module.exports = config